/**
 * Client fetcher dla komponentu `c_files_to_download` (Pliki do pobrania).
 *
 * Idzie przez Next.js route handler proxy `app/api/c-files-to-download/list`,
 * który dokłada X-API-Key (oraz Bearer zalogowanego usera - dla plikow
 * z ograniczeniem dostepu). Zwraca slice plikow + metadane paginacji.
 *
 * Endpoint backendu (REST):
 *   - GET /IRESTAPI/v1/C_FILES_TO_DOWNLOAD_CONTROLLER/listFiles/{id_catalog}?page=&category=
 */

import type {
  CFilesToDownloadItem,
  CFilesToDownloadPagination,
} from "@/lib/api/cms-catalog";

export type FilesListResult = {
  items: CFilesToDownloadItem[];
  pagination: CFilesToDownloadPagination;
  selected_category: number;
};

/**
 * Pobiera stronę listy plikow (z opcjonalnym filtrem kategorii).
 *
 * @param idCatalog ID katalogu komponentu c_files_to_download
 * @param page      Numer strony (1-based)
 * @param category  ID kategorii filtra (0 = wszystkie)
 * @returns Lista plikow + paginacja, lub null gdy fetch sie nie powiodl
 */
export async function fetchFilesList(
  idCatalog: number,
  page: number,
  category: number,
): Promise<FilesListResult | null> {
  const qs = new URLSearchParams();
  qs.set("id_catalog", String(idCatalog));
  qs.set("page", String(page));
  qs.set("category", String(category));

  try {
    const res = await fetch(`/api/c-files-to-download/list?${qs.toString()}`, {
      cache: "no-store",
    });
    if (!res.ok) return null;
    return (await res.json()) as FilesListResult;
  } catch {
    return null;
  }
}
